import { render, staticRenderFns } from "./CrearUsuario.vue?vue&type=template&id=45abee6a&"
import script from "./CrearUsuario.vue?vue&type=script&lang=js&"
export * from "./CrearUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports